<div class="date-filter">
  <div class="date-filter__date-wrapper">
    <div *ngIf="showMessage">
      <label class="bz-label-field" *ngIf="message">{{message}}</label>
      <label class="bz-label-field" *ngIf="!message">{{'GLOBAL.DATE_RANGE' | translate}}</label>
    </div>
    <div class="date-filter__date">
      <div class="bz-input-icon bz-space--inline-s" [ngClass]="{'disabled-input': isDisabled}">
        <input #dpFromInput class="bz-input bz-input-icon__input bz-space--inline-s"
            autocomplete="off"
            placeholder="{{'GLOBAL.FROM' | translate}}"
            mask="00/00/0000 00:00"
            id="date-from"
            #dpFrom="bsDatepicker"
            (focusin)="dpTo.hide()"
            [(ngModel)]="dateMin"
            (click)="setDatePickerActive('dpFrom', 0)"
            (ngModelChange)="onDateMinChange($event)"
            [bsConfig]="{ maxDate: dateMax, showWeekNumbers: false, dateInputFormat: 'DD/MM/YYYY HH:mm' }"
            [disabled]="isDisabled"
            bsDatepicker>
        <svg class="bz-icon" height="32px" width="32px" (click)="setDatePickerActive('dpFrom', 0); dpFrom.show()" [ngClass]="{'disabled': isDisabled}">
            <use href="#icon-calendar2"></use>
        </svg>
        <svg class="bz-icon bz-icon-mr" height="32px" width="32px" (click)="setDatePickerActive('dpFrom', 1)" [ngClass]="{'disabled': isDisabled}">
            <use href="#icon-timer"></use>
        </svg>
        <bz-time-picker class="bz-timer-positon" *ngIf="timePickers.dpFrom" [(dateInput)]="dateMin" [isVisible]="timePickers.dpFrom" (timeChange)="updateDate($event, 0)"></bz-time-picker>
      </div>
      <div class="bz-input-icon" [ngClass]="{'disabled-input': isDisabled}">
        <input #dpToInput class="bz-input bz-input-icon__input bz-space--inline-s"
          autocomplete="off"
          placeholder="{{'GLOBAL.TO' | translate}}"
          mask="00/00/0000 00:00"
          id="date-to"
          #dpTo="bsDatepicker"
          (focusin)="dpFrom.hide()"
          [(ngModel)]="dateMax"
          (click)="setDatePickerActive('dpTo', 0)"
          (ngModelChange)="onDateMaxChange($event)"
          [bsConfig]="{ minDate: dateMin, showWeekNumbers: false, dateInputFormat: 'DD/MM/YYYY HH:mm' }"
          [disabled]="isDisabled"
          bsDatepicker>
        <svg class="bz-icon" height="32px" width="32px" (click)="setDatePickerActive('dpTo', 0); dpTo.show()" [ngClass]="{'disabled': isDisabled}">
          <use href="#icon-calendar2"></use>
        </svg>
        <svg class="bz-icon bz-icon-mr"  height="32px" width="32px" (click)="setDatePickerActive('dpTo', 1)" [ngClass]="{'disabled': isDisabled}">
          <use href="#icon-timer"></use>
        </svg>
        <bz-time-picker class="bz-timer-positon" *ngIf="timePickers.dpTo" [(dateInput)]="dateMax" [isVisible]="timePickers.dpTo" (timeChange)="updateDate($event, 1)"></bz-time-picker>
      </div>
    </div>
  </div>
  <div class="date-filter__selector">
    <ng-content></ng-content>
  </div>
  <div class="date-filter__button" *ngIf="!isEventChange">
    <bzg-button-primary (click)="isValidDate(dateMin) && isValidDate(dateMax) && filter()" [disabled]="!isValidDate(dateMin) || !isValidDate(dateMax)">
      {{'GLOBAL.APPLY' | translate}}
    </bzg-button-primary>
  </div>
</div>

